import styled, { createGlobalStyle, keyframes } from 'styled-components';

const fadeIn = keyframes`
from { opacity: 0 }
to { opacity: 1 }
`;

const scaleIn = keyframes`
from { transform: scale(0.8); opacity: 0 }
to { transform: scale(1); opacity: 1 }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: hidden;
  cursor: pointer;
`;

export const ModalImage = styled.img`
  border-radius: 2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  user-select: none;
  pointer-events: all;
`;

export const FadeScaleAnimation = createGlobalStyle`
@keyframes fadeIn {
from { opacity: 0 }
to { opacity: 1 }
}

@keyframes scaleIn {
from { transform: scale(0.8); opacity: 0 }
to { transform: scale(1); opacity: 1 }
}
`;
